import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { VStack } from '../../layouts/stack.layout';
import Heading from '../../typography/v2/heading';
import Container from '../container';

type Props = {
  children: ReactNode;
  path: string;
  title: string;
};

export default function AsideSection({ children, path, title }: Props) {
  const navigate = useNavigate();
  return (
    <VStack extensions="w-full">
      <Container extensions="w-full px-[40px] py-5 border-y border-dark-gray bg-white/[2.5%]">
        <Heading variant="tertiary" color="primary">
          {title}
        </Heading>
      </Container>
      <VStack extensions="w-full">{children}</VStack>
      <Container
        onClick={() => navigate(path)}
        extensions="cursor-pointer py-4 w-full hover:bg-white/[5%] ease-in transition-all"
      >
        <Container extensions="px-[50px] font-text text-xs font-medium px-5 uppercase">
          View More
        </Container>
      </Container>
    </VStack>
  );
}
